<div class="m-subheader">
	<div class="d-flex align-items-center">
		<div class="mr-auto">
			<h3 class="m-subheader__title m-subheader__title--separator">
				Applicant Dashboard
			</h3>
		</div>
	</div>
</div>
<div class="m-content padding">
	<div class="m-content padding">
		<div class="m-portlet">
			<div class="m-portlet__body">
				<div class="row">
					<div class="col-4">
						<h3>Certification</h3>
					</div>
					<div class="col-8" style="padding-left: 28%;">
						<button class="btn btn-info notranslate" (click)="addCertification()">Add Basic
							Certification</button>
						<button class="btn btn-info notranslate" (click)="advanceCertificate('approved')">Add Advanced
							Certification</button>
					</div>
				</div>
				<hr>
				<span *ngIf="activeTab === 'approved'" style="color: blue;">*To raise ‘Advanced Certificate’ request,
					kindly click on ‘Action’ button against desired job role from the list of approved certificates
					below, and select ‘Add Advanced Certificate’.
					<hr>
				</span>
				<ul class="nav nav-tabs m-tabs-line m-tabs-line--info" role="tablist">
					<li class="nav-item m-tabs__item" (click)="changeCurrentStep('notApproved'); resetSearch();">
						<a class="nav-link m-tabs__link link active" [ngClass]="{ 'active':activeTab === 'pending'}"
							data-toggle="tab" role="tab">
							Pending Certificate Requests
						</a>
					</li>
					<li class="nav-item m-tabs__item" (click)="changeCurrentStep('approved'); resetSearch();">
						<a class="nav-link m-tabs__link link" [ngClass]="{ 'active':activeTab === 'approved'}"
							data-toggle="tab" role="button">
							Approved Certificate Requests
						</a>
					</li>
					<li class="nav-item m-tabs__item" (click)="changeCurrentStep('rejected'); resetSearch();">
						<a class="nav-link m-tabs__link link" [ngClass]="{ 'active':activeTab === 'rejected'}"
							data-toggle="tab" role="button">
							Rejected Certificate Requests
						</a>
					</li>
				</ul>
				<app-tot-toa-data-filter #filters [customFilter]="customFilterFields"
					(searchFilters)="getFilterData($event)" (resetFilters)="resetFilter()"></app-tot-toa-data-filter>
				<div class="tab-content">
					<div class="tab-pane active" role="tabpanel">
						<div *ngIf="currentStep===1 || currentStep===3">
							<div class="m-portlet__body">
								<div class="form-group m-form__group row">
									<table class="col-sm-11 table table-striped m-table">
										<thead>
											<tr>
												<th>
													<b>Sr. No.</b>
												</th>
												<th>
													<b>Sector Skill Council</b>
												</th>
												<th>
													<b>Batch Type</b>
												</th>
												<th>
													<b>Batch Mode</b>
												</th>
												<th>
													<b>Job Role Name (QP Code)</b>
												</th>
												<th>
													<b>User Type</b>
												</th>
												<th>
													<b>Certification ID</b>
												</th>
												<!-- <th>
                                                        <b>Valid Till</b>
                                                    </th> -->
												<th>
													<b>Certificate Type</b>
												</th>
												<th>
													<b>Submitted On</b>
												</th>
												<th>
													<b>Status</b>
												</th>
												<th>
													<b>Action</b>
												</th>
											</tr>
										</thead>
										<tbody class="notranslate">
											<tr *ngFor="let certificate of totalCertificates; let i=index">
												<td>{{i+1}}</td>
												<td>{{certificate.sector?.name}}</td>
												<td>
													<span
														*ngIf="certificate.batchType && certificate.batchType.name && certificate.batchType.name !=='' ;else elseBlockA">{{certificate.batchType.name}}
													</span>
													<ng-template #elseBlockA>N/A</ng-template>
												</td>
												<td>
													{{certificate.batchMode}}
												</td>
												<td>{{certificate.jobName ? certificate.jobName :"N/A"}}
													({{certificate.jobRoleId}}) - v{{certificate.version}}</td>
												<td style="text-transform: capitalize">
													{{certificate.certificateDetails.certificateType ? certificate.certificateDetails.certificateType :"N/A"}}
												</td>
												<td>{{certificate.certificateDetails.certificateID ? certificate.certificateDetails.certificateID :"N/A"}}
												</td>
												<td>{{certificate.certificateDetails.typeOfCertification ? certificate.certificateDetails.typeOfCertification :"N/A"}}
												</td>
												<!-- <td>
                                                            <span *ngIf="certificate.certificateDetails && certificate.certificateDetails.certificateValidTillDate; else elseBlock">
                                                                {{certificate.certificateDetails.certificateValidTillDate | date : 'dd/MM/yyyy'}}</span>
                                                            <ng-template #elseBlock>N/A</ng-template>
                                                        </td> -->
												<td>
													<span *ngIf="certificate.submittedOn; else elseNoDate">
														{{certificate.submittedOn | date : 'dd/MM/yyyy'}}
													</span>
													<ng-template #elseNoDate>N/A</ng-template>
												</td>
												<td>{{certificate.certificateDetails.certificateStatus ? certificate.certificateDetails.certificateStatus :"N/A"}}
												</td>
												<td data-field="Actions" class="m-datatable__cell">
													<span style="overflow: visible; width: 100px;"
														*ngIf="certificate.certificateDetails.certificateStatus==='REJECTED'">
														<div class="dropdown">
															<a href="#"
																class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
																data-toggle="dropdown">
																<i class="la la-ellipsis-h"></i>
															</a>
															<div class="dropdown-menu dropdown-menu-right">
																<span class="dropdown-item" style="cursor: pointer"
																	*ngIf="certificate.remarks&&certificate.remarks.bySSC&&certificate.remarks.bySSC.length>0"
																	data-toggle="modal"
																	data-target="#certificationComments"
																	(click)="getRemarks(certificate.remarks)">
																	View Comments
																</span>
																<span class="dropdown-item"
																	(click)="editJobRole(certificate)"
																	style="cursor: pointer" data-toggle="modal"
																	data-target="#certificationComments">
																	Edit Certificate Details
																</span>
															</div>
														</div>
													</span>
												</td>
											</tr>
											<tr
												*ngIf="totalCertificates === null || totalCertificates === undefined || count == 0">
												<td colspan="9">No Data Found</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div *ngIf="currentStep === 2">
							<div class="form-group m-form__group row">
								<table class="col-sm-11 table table-striped m-table">
									<thead>
										<tr>
											<th>
												<b>Sr. No.</b>
											</th>
											<th>
												<b>Sector Skill Council</b>
											</th>
											<th>
												<b>Batch Type</b>
											</th>
											<th>
												<b>Batch Mode</b>
											</th>
											<th>
												<b>Job Role Name (QP Code)</b>
											</th>
											<th>
												<b>User Type</b>
											</th>
											<th>
												<b>Certification ID</b>
											</th>
											<th>
												<b>Certificate Type</b>
											</th>
											<th>
												<b>Valid Till</b>
											</th>
											<th>
												<b>Submitted On</b>
											</th>
											<th>
												<b>Validity Extended</b>
											</th>
											<th>
												<b>Grade</b>
											</th>
											<th>
												<b>Action</b>
											</th>
										</tr>
									</thead>
									<tbody class="notranslate">
										<tr *ngFor="let certificate of totalCertificates; let i=index">
											<td>{{i+1}}</td>
											<td>{{certificate?.sector?.name?certificate?.sector?.name:"N/A"}}</td>
											<td>
												<span
													*ngIf="certificate.batchType && certificate.batchType.name && certificate.batchType.name !== '';else elseBlockA">{{certificate.batchType.name}}</span>
												<ng-template #elseBlockA>N/A</ng-template>
											</td>
											<td>
												{{certificate.batchMode}}
											</td>
											<td>{{certificate.jobName ? certificate.jobName :"N/A"}}
												({{certificate.jobRoleId}}) - v{{certificate.version}}</td>
											<td style="text-transform: capitalize">
												{{certificate.certificateDetails.certificateType ? certificate.certificateDetails.certificateType:"N/A"}}
											</td>
											<td>{{certificate.certificateDetails.certificateID ? certificate.certificateDetails.certificateID:"N/A"}}
											</td>
											<td>{{certificate.certificateDetails.typeOfCertification ? certificate.certificateDetails.typeOfCertification :"N/A"}}
											</td>
											<td *ngIf="certificate?.certificateDetails?.certificateValidTillDate">
												{{certificate.certificateDetails?.certificateValidTillDate | date :"dd/MM/yyyy"}}
											</td>
											<td>
												<span *ngIf="certificate.submittedOn; else noDate">
													{{certificate.submittedOn | date : 'dd/MM/yyyy'}}
												</span>
												<ng-template #noDate>N/A</ng-template>
											</td>
											<td *ngIf="!certificate?.certificateDetails?.certificateValidTillDate">N/A
											</td>
											<td>
												{{certificate.certificateDetails?.isValidityExtended ? 'Yes' : 'No'}}
											</td>
											<td>
												<span
													*ngIf="certificate.assmtCrt && certificate.assmtCrt.grade && certificate.assmtCrt.grade === 'C'">PROVISIONAL</span>
												<span
													*ngIf="certificate.assmtCrt && certificate.assmtCrt.grade && certificate.assmtCrt.grade === 'NOTCERTIFIED'">NOT
													CERTIFIED</span>
												<span
													*ngIf="certificate.assmtCrt && certificate.assmtCrt.grade && certificate.assmtCrt.grade !== 'C' && certificate.assmtCrt.grade !== 'NOTCERTIFIED'">{{certificate?.assmtCrt?.grade}}</span>
											</td>
											<td data-field="Actions" class="m-datatable__cell">
												<span style="overflow: visible; width: 100px;">
													<div class="dropdown"
														*ngIf="certificate?.assmtCrt?.grade !== 'NOTCERTIFIED'">
														<a href="#"
															class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
															data-toggle="dropdown">
															<i class="la la-ellipsis-h"></i>
														</a>
														<div class="dropdown-menu dropdown-menu-right">
															<span
																*ngIf="certificate.remarks&&certificate.remarks.bySSC&&certificate.remarks.bySSC.length>0"
																class="dropdown-item" style="cursor: pointer"
																data-toggle="modal"
																(click)="getRemarks(certificate.remarks)"
																data-target="#certificationComments">
																View Comments
															</span>
															<span class="dropdown-item" style="cursor: pointer"
																(click)="downloadCertificate(certificate)">
																Download Certificate
															</span>
															<span class="dropdown-item" style="cursor: pointer"
																data-toggle="modal"
																data-target="#provide_feedback_modal"
																*ngIf="!certificate?.certificateDetails?.feedback"
																(click)="provideFeedback(certificate)">
																Provide Feedback
															</span>
															<span class="dropdown-item" style="cursor: pointer"
																data-toggle="modal" data-target="#view_feedback_modal"
																*ngIf="certificate?.certificateDetails?.feedback"
																(click)="viewFeedback(certificate)">
																View Feedback
															</span>
															<span
																*ngIf="certificate?.certificateDetails?.typeOfCertification !== 'Advanced'"
																class="dropdown-item" style="cursor: pointer"
																(click)="applyForAdvanceCertificate(certificate)">
																Add Advanced Certificate
															</span>
															<span
																*ngIf="certificate?.certificateDetails?.certificateStatus === 'APPROVED'"
																class="dropdown-item" style="cursor: pointer"
																data-toggle=""
																(click)="viewCertificateDetails(certificate)">
																View Details
															</span>
														</div>
													</div>
												</span>
											</td>
										</tr>
										<tr *ngIf="totalCertificates === undefined || count == 0">
											<td colspan="9">No Data Found</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div *ngIf="count > 10">
							<app-pagination [count]="count" (pageNumber)="getPageNo($event)"
								(recordsPerPage)="getPerPage($event)" [defaultRecordsPerPage]="perPage">
							</app-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- Model -->

<div class="modal fade" id="m_modal_2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle">
	<div class="modal-dialog align " role="document">
		<div class="modal-content align_content">
			<div class="modal-header">
				<h3 id="exampleModalLongTitle">View Certificate Details
				</h3>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">×</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Applicant ID: </B>{{currentCertificate?.userName}}
						</div>
						<div class="col-md-4">
							<B>Applicant Name: </B>{{currentCertificate?.name}}
						</div>
						<div class="col-md-4">
							<B>User Type: </B>
							{{currentCertificate?.certificateDetails && currentCertificate?.certificateDetails?.certificateType ? currentCertificate?.certificateDetails?.certificateType :'N/A'}}
						</div>
					</div>
				</div>
				<br>
				<hr>
				<!-- <div class="col-md-12">
                        <h3>Certification Details</h3>
                    </div> -->
				<br>
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Job Role (QP Code):
							</B>{{currentCertificate?.jobName ? currentCertificate?.jobName : 'N/A'}}
							({{currentCertificate?.jobRoleId}}) - v{{currentCertificate?.version}}
						</div>
						<div class="col-md-4">
							<B>Country: </B>
							{{currentCertificate?.address?.country?.name?currentCertificate?.address?.country?.name:'N/A'}}
						</div>
						<div class="col-md-4">
							<B>State: </B>
							{{currentCertificate?.address?.state?.name?currentCertificate?.address?.state?.name:'N/A'}}
						</div>
					</div>
				</div>
				<br>
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>District:
							</B>{{currentCertificate?.address?.district?.name?currentCertificate?.address?.district?.name:'N/A'}}
						</div>
						<div class="col-md-4">
							<B>Certificate ID:
							</B>{{currentCertificate?.certificateDetails?.certificateID ? currentCertificate?.certificateDetails?.certificateID:"N/A"}}
						</div>
						<div class="col-md-4">
							<B>Certificate Issue Date: </B>
							<span
								*ngIf="currentCertificate?.certificateDetails && currentCertificate?.certificateDetails?.certificateIssueDate; else elseBlockA">{{currentCertificate?.certificateDetails?.certificateIssueDate | date: 'dd/MM/yyyy'}}</span>
							<ng-template #elseBlockA>N/A</ng-template>
						</div>
					</div>
				</div>
				<br>
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Valid Till Date: </B>
							<span
								*ngIf="currentCertificate?.certificateDetails && currentCertificate?.certificateDetails?.certificateValidTillDate; else elseBlockB">{{currentCertificate?.certificateDetails?.certificateValidTillDate | date: 'dd/MM/yyyy'}}</span>
							<ng-template #elseBlockB>N/A</ng-template>
						</div>
						<div class="col-md-4">
							<B>Domain Percentage:
							</B>{{currentCertificate?.assmtCrt?.percentage?currentCertificate?.assmtCrt?.percentage:"N/A"}}
						</div>
						<div class="col-md-4">
							<B>Platform Percentage:
							</B>{{currentCertificate?.platformPercentage?currentCertificate?.platformPercentage:"N/A"}}
						</div>
					</div>
				</div>
				<br>
				<div class="col-md-12">
					<div class="row">
						<div class="col-md-4">
							<B>Certificate/Provisional Certificate Document: </B>
							<span class="" *ngIf="certificateFileName; else noCertificateDoc">
								<div (click)="downloadCertificate(currentCertificate?.certificateDetails?.certificateURLDetails)"
									style="color:#0092D8;cursor: pointer;">
									{{certificateFileName}}
								</div>
							</span>
							<ng-template #noCertificateDoc>N/A</ng-template>
						</div>
						<div class="col-md-4">
							<B>Supporting Document Details: </B>
							<span class=""
								*ngIf="currentCertificate?.certificateDetails?.supportingDocumentURLDetails && currentCertificate.certificateDetails.supportingDocumentURLDetails.location !== '' ; else elseBlock">
								<div (click)="downloadCertificate(currentCertificate?.certificateDetails?.supportingDocumentURLDetails)"
									style="color:#0092D8;cursor: pointer;">
									{{ fileName }}
								</div>
							</span>
							<ng-template #elseBlock>NA</ng-template>
						</div>
						<div class="col-md-4">
							<B>Remarks to SSC:
							</B>{{currentCertificate?.remarks?.toSSC?.comment?currentCertificate?.remarks?.toSSC?.comment:"N/A"}}
						</div>
					</div>
				</div>
				<br>
				<div class="col-md-12" *ngIf="currentCertificate?.certificateDetails?.certificateStatus === 'APPROVED'">
					<div class="row">
						<div class="col-md-4">
							<B>Validity Extended: </B>
							<span>{{currentCertificate?.certificateDetails?.isValidityExtended ? 'Yes' : 'No' }}</span>
						</div>
						<div class="col-md-8" *ngIf="currentCertificate?.certificateDetails?.isValidityExtended">
							<B>Extended Validity: </B> <span>Valid Till Date extended from</span>
							{{ currentCertificate?.certificateDetails?.validityExtensionDetails?.oldValidityDate | date: 'dd/MM/yyyy' }}<span>
								to </span> {{ currentCertificate?.certificateDetails?.certificateValidTillDate
                            | date: 'dd/MM/yyyy' }} <span>under special circumstances –</span>
							{{ currentCertificate?.certificateDetails?.validityExtensionDetails?.reasonForValidityExtension }}
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer default">
				<button type="button" class="btn btn-secondary" data-dismiss="modal">close</button>
			</div>
		</div>
	</div>
</div>

<!-- <div class="modal fade" id="certification_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="exampleModalLabel">
                    Choose Certification Type for which you want to apply
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body" style="margin-left: 1rem;">
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="typeOfCertification" id="typeOfCertification" value="Basic">
                    <label class="form-check-label" for="flexRadioDefault1">
                       <strong>Basic Certification</strong>
                    </label>
                  </div>
                  <br>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="typeOfCertification" id="typeOfCertification" value="Advanced">
                    <label class="form-check-label" for="flexRadioDefault2">
                       <strong>Advanced Certification</strong>
                    </label>
                  </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary">
                    Apply
                </button>
            </div>
        </div>
    </div>
</div> -->

<div class="modal fade" id="certificationComments" *ngIf="remarks.length>0" tabindex="-1" role="dialog"
	aria-labelledby="exampleModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Received Comments
				</h5>
				<button type="button" #closeModal class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<!-- <div class="row" style="padding-left:2%;padding-right:2%;padding-top:2%;">
                        <div class="col-10">
                            <P style="font-size:25px">Received Comments</P>
                        </div> -->
			<!-- <div class="col-1 flaticon-cancel" style="font-size:25px"></div> -->
			<!-- </div> -->
			<hr>
			<div class="row" style="margin-left:2%">
				<div>
					<P *ngFor="let comment of remarks let i = index">
						<b>Comments by SSC on {{comment.commentedOn |date: 'dd/MM/yyyy, h:mm a'}} :</b>
						{{comment.comment}}
						<br>
					</P>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Previde Feedback Modal -->
<div class="modal fade" id="provide_feedback_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true" style="margin-right: 8rem;">
	<div class="modal-dialog modal-lg" role="document">
		<div *ngIf="isFeedback" class="modal-content" style="width: 71rem;">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					How would you rate your experience?
				</h5>
				<button type="button" #closeModal class="close" (click)="cancelFeedbackForm()" data-dismiss="modal"
					aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m-section">
					<div class="m-section__content">
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Trainer ID:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.userName ? selectedCertificate.userName : 'N/A'}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Trainer Name:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.name ? selectedCertificate.name : 'N/A' }}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch ID:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.batchId ?  selectedCertificate.batchId : 'N/A'}}
								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Batch Name:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.batchType.name ? selectedCertificate.batchType.name : 'N/A'}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch Date: </b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{(selectedCertificate?.batchStartDate ? (selectedCertificate.batchStartDate| date:"dd-MM-yyyy") : "N/A")}}
									to
									{{(selectedCertificate?.batchEndDate ? (selectedCertificate.batchEndDate | date:"dd-MM-yyyy") : "N/A")}}
								</div>
							</div>
							<!-- <label class="col-lg-1">
                                <b>Batch Type:</b>
                            </label>
                            <div class="col-lg-3">
                                <div class="m-input-icon m-input-icon--right">
                                    {{ selectedCertificate.batchId ? selectedCertificate.batchId : 'N/A'}}
                                </div>
                            </div> -->
							<label class="col-lg-1">
								<b>Date of Submission:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.certificateDetails.feedback ? (selectedCertificate.certificateDetails.feedback.date | date: "dd-MM-yyyy") : (todayDate | date: "dd-MM-yyyy")}}
								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Batch Mode:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.totMode || 'N/A'}}
								</div>
							</div>
						</div>
						<hr>
						<form class="m-form">
							<div [formGroup]="feedBackForm">
								<div formGroupName="feedBack">
									<div formGroupName="feedbackForTC">
										<div class="row" style="padding-left: 1rem;">
											<span *ngIf="isTrainingCenter" class="col-8">
												<button class="btn btn-info notranslate" (click)="searchTC()"
													type="button" class="btn btn-secondary">Search Training
													Centre</button>
											</span>
											<label class="m-checkbox">
												<input type="checkbox" (click)="checkTCValidity($event)"><b>Don't know
													Training Centre details</b>
												<span></span>
											</label>
										</div>
										<div *ngIf="isTrainingCenter" class="row"
											style="padding-bottom: 7px; padding-top: 15px;">
											<label class="col-12">
												<b>Training Centre ID:
													{{ (selectedTC ? selectedTC.trainingCentreId : 'N/A') }}</b>
											</label>
										</div>
										<div *ngIf="isTrainingCenter" class="row">
											<label class="col-12">
												<b>Training Centre Name:
													{{selectedTC ? selectedTC.trainingCentreName : 'N/A'}}</b>
											</label>
										</div>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Pre-program communication (including ease of
													enrollment and availability of pre-read material):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Content Quality of Study Materials:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Quality of Training/ Assessment Location (or
													Training/ Assessment Platform in case of Online mode):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Quality of Training and Assessment Tools, Equipment
													and Infrastructure:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=4 class="radio" type="radio">
														<span></span>
													</label>

												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Post-program communication/ instructions (including
													support with Skill India Digital Hub, OJT briefing):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<hr>
									<div class="form-group m-form__group row">
										<span class="col-12" formGroupName="feedbackForMT">
											<div class="row" style="padding-left: 1rem;">
												<span *ngIf="isTrainer" class="col-8">
													<button class="btn btn-info notranslate" (click)="searchTrainer()"
														type="button" class="btn btn-secondary">Search Master
														Trainer</button>
												</span>
												<label class="m-checkbox">
													<input type="checkbox"
														(click)="checkTrainerValidity($event)"><b>Don't
														know Master Trainer Details</b>
													<span></span>
												</label>
											</div>
											<div *ngIf="isTrainer" class="row"
												style="padding-bottom: 7px; padding-top: 15px;">
												<label class="col-12">
													<b>Master Trainer ID:
														{{ selectedTrainer ? selectedTrainer.userName : 'N/A' }}</b>
												</label>
											</div>
											<div *ngIf="isTrainer" class="row">
												<label class="col-12">
													<b>Master Trainer Name:
														{{ selectedTrainer ? selectedTrainer.name : 'N/A'}}</b>
												</label>
											</div>
											<table class="col-lg-12">
												<thead>
													<th class="width1"></th>
													<th>Highly Satisfied (5)</th>
													<th>Satisfied (4)</th>
													<th>Neutral (3)</th>
													<th>Dissatisfied (2)</th>
													<th>Highly Dissatisfied (1)</th>
												</thead>
												<tr>
													<td class="width1">Knowledge of Subject:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Organization and preparation of the sessions:
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Presentation Style and Delivery:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=5 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=4 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=2 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Usage of Examples of Practical Application:
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=5 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=4 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=2 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Interactive & Participative Approach:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=5 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=4 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=2 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Coverage of Curriculum:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=5 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=4 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=2 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
											</table>
										</span>
									</div>
									<hr>
									<div formGroupName="feedbackForMTTraining">
										<label class="form-group m-form__group">
											<b>Feedback on Training:</b>
										</label>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Extent of Learning:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Learning Environment:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<hr>
									<div formGroupName="feedbackForAssessor">
										<div class="row" style="padding-left: 1rem;">
											<span *ngIf="isAssessor" class="col-8">
												<button class="btn btn-info notranslate" (click)="searchAssessor()"
													type="button" class="btn btn-secondary">Search Assessor</button>
											</span>
											<label class="m-checkbox">
												<input type="checkbox" (click)="checkAssessorValidity($event)"><b>Don't
													know Assessor Details</b>
												<span></span>
											</label>
										</div>
										<div *ngIf="isAssessor" class="row"
											style="padding-bottom: 7px; padding-top: 15px;">
											<label class="col-12">
												<b>Assessor ID:
													{{ selectedAssessor ? selectedAssessor.userName : 'N/A' }}</b>
											</label>
										</div>
										<div *ngIf="isAssessor" class="row">
											<label class="col-12">
												<b>Assessor Name:
													{{ selectedAssessor ? selectedAssessor.name : 'N/A'}}</b>
											</label>
										</div>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Pre-Assessment Brief:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Conduct of Assessor:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=5
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=4
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=3
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=2
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=1
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Overall Assessment Experience:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<div class="form-group m-form__group row align-data">
										<label class="form-group m-form__group">
											<b>Overall Program Rating</b>
										</label>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Overall Program Rating:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=3 class="radio" type="radio"
															[checked]="overAllRating?.value">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=2 type="radio" class="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
										<hr>
									</div>
									<div class="form-group m-form__group row align-data">
										<label class="form-group m-form__group col-12">
											<b>Would you recommend this program to other trainers/assessors?</b>
										</label>
										<td class="width3 col-2">
											<label for="radio">Yes</label>
											<label class="radio">
												<input formControlName="recommendation" name="recommendation"
													value="Yes" class="radio" type="radio">
												<span></span>
											</label>
										</td>
										<td class="width4">
											<label for="radio">No</label>
											<label class="radio">
												<input formControlName="recommendation" name="recommendation" value="No"
													class="radio" type="radio">
												<span></span>
											</label>
										</td>
										<hr>
									</div>
									<div>
										<label class="form-group m-form__group">
											Comment:
											<span class="red">*</span>
										</label>
										<div>
											<textarea type="text" formControlName="overAllComment"
												class="form-control m-input" rows="5"
												placeholder="Your comments goes here..."></textarea>
											<app-form-control-messages class="col-12"
												[control]="feedBackForm.get('feedBack').get('overAllComment')['controls']"
												[name]="'Comments'"></app-form-control-messages>
										</div>
									</div>
									<div class="modal-footer">
										<button type="submit" class="btn btn-primary" data-dismiss="modal"
											[disabled]="!feedBackForm.valid" (click)="feedbackSubmitted()">
											Submit Feedback
										</button>
										<button type="button" class="btn btn-secondary" data-dismiss="modal"
											(click)="cancelFeedbackForm()">
											Cancel
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>

<!-- Assign TC Start -->
<div class="modal fade" id="assign_tc" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Search Training Centre
				</h5>
				<button type="button" (click)="resetTrainingCentreFilter()" #closeModal class="close"
					data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="m-portlet__body">
				<div class="tab-content" [formGroup]="trainingCentreSearchForm">
					<div class="form-group m-form__group">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-5">
									<label>
										State:
									</label>
									<div class="notranslate">
										<angular2-multiselect (onOpen)="stateClick()" (onSelect)="onStateSelect($event)"
											formControlName="state" [data]="stateDropDownData"
											[(ngModel)]="selectedItemsState" [settings]="settings"
											formControlName="state">
										</angular2-multiselect>
										<app-form-control-messages class="col-12"
											[control]="trainingCentreSearchForm.get('state')" [name]="'State'">
										</app-form-control-messages>
									</div>
								</div>
								<div class="col-md-5">
									<label>
										District:
									</label>
									<div class="notranslate">
										<angular2-multiselect (onOpen)="districtClick()" formControlName="district"
											(onSelect)="onDistrictSelect($event)" [data]="districtDropDownData"
											[(ngModel)]="selectedItemsDistrict" [settings]="settings">
										</angular2-multiselect>
										<app-form-control-messages class="col-12"
											[control]="trainingCentreSearchForm.get('district')" [name]="'District'">
										</app-form-control-messages>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-5">
									<label>
										Training Centre ID:
									</label>
									<input class="notranslate" type="text" formControlName="trainingCentreId"
										placeholder="Enter training centre id" class="form-control">
								</div>
								<div class="col-md-5">
									<label>
										Training Centre Name:
									</label>
									<input class="notranslate" type="text" formControlName="trainingCentreName"
										placeholder="Enter training centre Name" class="form-control">
								</div>
							</div>
						</div>
						<div class="col-md-12" style="margin-left: 38rem;">
							<div class="row">
								<!-- <div class="col-md-5">
                                    <label>
                                        Type :
                                    </label>
                                    <div class="notranslate">
                                        <input class="notranslate" type="text" formControlName="trainingCentreType"
                                            placeholder="Enter training centre type" class="form-control">
                                    </div>
                                </div> -->
								<div style="margin-top:30px">
									<button type="button" #search (click)="searchTC()"
										class="btn btn-secondary">Search</button>
								</div>
								<div style="margin-top:30px">
									<button type="button" #search (click)="resetTrainingCentreFilter('true')"
										class="btn btn-secondary">Reset</button>
								</div>
							</div>
						</div>
						<div class="col-md-12" style="margin-top : 30px">
							<div class="row">
								<div class="col-md-5">
									<ul class="nav nav-pills nav-fill">
										<li class="nav-item">
											<a class="nav-link" [ngClass]="{'active' : allTcTab }" (click)="tc_tab()">
												All Training Centre
											</a>
										</li>
									</ul>
								</div>
								<div class="col-md-5">
									<ul class="nav nav-pills nav-fill">
										<li class="nav-item">
											<a class="nav-link" [ngClass]="{'active' : previouslyConductedTcTab }"
												(click)="previouslyConductedTc_tab()" data-toggle="tab"
												href="#m_tabs_5_2">
												Exclusive TOT/TOA Centres
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-md-12">
							<div class="tab-content">
								<div class="tab-pane active" *ngIf="allTcTab">
									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>
														Training Centre Name
													</th>
													<th>
														Training Centre ID
													</th>
													<th>
														Centre Rating
													</th>
													<th>
														Training Partner Name
													</th>
													<th>
														State
													</th>
													<th>
														District
													</th>
													<th>
														Action
													</th>
												</tr>
											</thead>
											<tbody class="notranslate">
												<tr *ngFor="let centre of trainingCentres; let i = index">
													<td>
														{{centre.trainingCentreName}}
													</td>
													<td>
														{{centre.trainingCentreId}}
													</td>
													<td>
														{{centre.rating}}
													</td>
													<td>
														{{centre.trainingPartnerName? centre.trainingPartnerName:'NA'}}
													</td>
													<td>
														{{centre.state}}
													</td>
													<td>
														{{centre.district}}
													</td>
													<td>
														<input type="radio" name="lo" (click)="tab_1(centre, i)"
															class="form-control">
													</td>
												</tr>
											</tbody>
										</table>
										<div *ngIf="lengthTab_1>9">
											<app-pagination [count]="lengthTab_1"
												(pageNumber)="assignPageNoTab_1($event)"
												(recordsPerPage)="assignRecordsPerPageTab_1($event)">
											</app-pagination>
										</div>
									</div>
									<div class="m-portlet__foot">
										<div class="row">
											<div class="col-lg-6">
												&nbsp;
											</div>
											<div class="col-lg-6 m--align-right">
												<button (click)="assignedTc()" class="btn btn-brand">Submit</button>
												<button (click)="resetTrainingCentreFilter()" class="btn btn-default"
													#closeSearchTC data-dismiss="modal">Cancel</button>
											</div>
										</div>
									</div>

								</div>
								<div class="tab-pane active" id="m_tabs_5_2" role="tabpanel"
									*ngIf="previouslyConductedTcTab">
									<div class="table-responsive">
										<table class="table">
											<thead>
												<tr>
													<th>
														Training Centre Name
													</th>
													<th>
														Training Centre ID
													</th>
													<th>
														Centre Rating
													</th>
													<th>
														Training Partner Name
													</th>
													<th>
														State
													</th>
													<th>
														District
													</th>
													<th>
														Action
													</th>
												</tr>
											</thead>
											<tbody class="notranslate">
												<tr
													*ngFor="let centre of previouslyConductedTrainingCentres; let j = index">
													<td>
														{{centre.trainingCentreName}}
													</td>
													<td>
														{{centre.trainingCentreId}}
													</td>
													<td>
														{{centre.rating}}
													</td>
													<td>
														{{centre.trainingPartnerName}}
													</td>
													<td>
														{{centre.state}}
													</td>
													<td>
														{{centre.district}}
													</td>
													<td>
														<input type="radio" name="lo" (change)="tab_2(centre,j)"
															class="form-control">
													</td>
												</tr>
											</tbody>
										</table>
										<div *ngIf="lengthTab_2>9">
											<app-pagination [count]="lengthTab_2"
												(pageNumber)="assignPageNoTab_2($event)"
												(recordsPerPage)="assignRecordsPerPageTab_2($event)">
											</app-pagination>
										</div>
									</div>
									<div class="m-portlet__foot">
										<div class="row">
											<div class="col-lg-6">
												&nbsp;
											</div>
											<div class="col-lg-6 m--align-right">
												<button (click)="assignedTc()" type="submit" [disabled]="tcIndex"
													class="btn btn-brand">Submit</button>
												<button (click)="resetTrainingCentreFilter()" class="btn btn-default"
													#closeFromPreviously data-dismiss="modal">Cancel</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- Assign TC end -->

<!-- Assign Trainer Start -->

<div class="modal fade" id="assign_master_trainer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Search Master Trainer
				</h5>
				<button type="button" (click)="resetTrainerFilter()" #closeModal class="close" data-dismiss="modal"
					aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="m-portlet__body">
				<div class="tab-content" [formGroup]="masterTrainerSearchForm">
					<div class="form-group m-form__group">
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-5">
									<label>State :</label>
									<div class="notranslate">
										<angular2-multiselect (onOpen)="stateClick()" (onSelect)="onStateSelect($event)"
											formControlName="state" [data]="stateDropDownData"
											[(ngModel)]="selectedItemsState" [settings]="settings">
										</angular2-multiselect>
										<app-form-control-messages class="col-12"
											[control]="masterTrainerSearchForm.get('state')" [name]="'State'">
										</app-form-control-messages>
									</div>
								</div>
								<div class="col-md-5">
									<label>District :</label>
									<div class="notranslate">
										<angular2-multiselect (onOpen)="districtClick()" formControlName="district"
											(onSelect)="onDistrictSelect($event)" [data]="districtDropDownData"
											[(ngModel)]="selectedItemsDistrict" [settings]="settings">
										</angular2-multiselect>
										<app-form-control-messages class="col-12"
											[control]="masterTrainerSearchForm.get('district')" [name]="'District'">
										</app-form-control-messages>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-5">
									<label>Master Trainer ID:</label>
									<input class="notranslate" type="text" formControlName="mtId"
										placeholder="Enter Master Trainer ID" class="form-control">
								</div>
								<div class="col-md-5">
									<label>Master Trainer Name</label>
									<input class="notranslate" type="text" formControlName="mtName"
										placeholder="Enter Master Trainer Name" class="form-control">
								</div>
								<div class="col-md-2" style="margin-top:30px">
									<button type="button" #search (click)="addTrainerFilters()"
										class="btn btn-secondary">Search</button>
								</div>
								<div class="col-md-1" style="margin-top:30px; margin-left: 2rem">
									<button type="button" (click)="resetTrainerFilter(true);"
										class="btn btn-secondary">Reset</button>
								</div>
							</div>
						</div>
						<div style="margin-top : 30px">
							<div class="table-responsive">
								<table class="notranslate table table-bordered">
									<thead>
										<tr>
											<th>
												Master Trainer ID
											</th>
											<th>
												Master Trainer Name
											</th>
											<th>
												State
											</th>
											<th>
												District
											</th>
											<th>
												Action
											</th>
										</tr>
									</thead>
									<tbody class="notranslate">
										<tr *ngFor="let trainer of masterTrainers; let i = index">
											<td>
												{{trainer.userName}}
											</td>
											<td>
												{{trainer.name}}
											</td>
											<td>
												{{trainer.address?.state?.name || 'N/A' }}
											</td>
											<td>
												{{trainer.address?.district?.name || 'N/A' }}
											</td>
											<td>
												<input type="radio" name="lo"
													(change)="selectedTrainerIndex(trainer, i)" class="form-control">
											</td>
										</tr>
									</tbody>
								</table>
								<div *ngIf="masterTrainers.length > 9">
									<app-pagination [count]=trainerLength (pageNumber)="assignPageNoMT($event)"
										(recordsPerPage)="assignRecordsPerPageMT($event)"></app-pagination>
								</div>
								<div class="m-portlet__foot">
									<div class="row">
										<div class="col-lg-6">
											&nbsp;
										</div>
										<div class="col-lg-6 m--align-right">
											<button (click)="assignedTrainer()" [disabled]="trainerIndex"
												class="btn btn-brand">Select</button>
											<button #closeMT (click)="resetTrainerFilter()" class="btn btn-default"
												data-dismiss="modal">Cancel</button>
										</div>
									</div>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Assign Trainer End -->

<!-- Assign Assessor Start-->
<div class="modal fade" id="assign_assessor" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Search Assessor
				</h5>
				<button type="button" (click)="resetAssessorFilter()" #closeModal class="close" data-dismiss="modal"
					aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="m-portlet__body">
				<div class="tab-content" [formGroup]="assessorSearchForm"
					style="padding-left: 2rem; padding-right: 2rem">
					<div class="form-group m-form__group">
						<div class="row">
							<div class="col-md-12">
								<div class="row">
									<div class="col-md-5">
										<label>
											State :
										</label>
										<div>
											<angular2-multiselect (onOpen)="stateClick()"
												(onSelect)="onStateSelect($event)" formControlName="state"
												[data]="stateDropDownData" [(ngModel)]="selectedItemsState"
												[settings]="settings" formControlName="state">
											</angular2-multiselect>
											<app-form-control-messages class="col-12"
												[control]="assessorSearchForm.get('state')" [name]="'State'">
											</app-form-control-messages>
										</div>
									</div>
									<div class="col-md-5">
										<label>
											District :
										</label>
										<div>
											<angular2-multiselect (onOpen)="districtClick()" formControlName="district"
												(onSelect)="onDistrictSelect($event)" [data]="districtDropDownData"
												[(ngModel)]="selectedItemsDistrict" [settings]="settings">
											</angular2-multiselect>
											<app-form-control-messages class="col-12"
												[control]="assessorSearchForm.get('district')" [name]="'District'">
											</app-form-control-messages>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-5">
										<label>
											Assessor ID:
										</label>
										<input type="text" formControlName="assessorId" placeholder="Enter Assessor ID"
											class="form-control notranslate">
									</div>
									<div class="col-md-4">
										<label>
											Assessor Name
										</label>
										<input type="text" formControlName="assessorName"
											placeholder="Enter Assessor Name" class="form-control notranslate">
									</div>
									<div class="col-md-1" style="margin-top:30px">
										<button type="button" #search (click)="addAssessorFilters()"
											class="btn btn-secondary">Search</button>
									</div>
									<div class="col-md-1" style="margin-top:30px; margin-left: 2rem">
										<button type="button" (click)="resetAssessorFilter('true')"
											class="btn btn-secondary">Reset</button>
									</div>
								</div>
							</div>
						</div>
						<div style="margin-top : 30px">
							<div class="row">
								<div class="table-responsive">
									<table class="table table-bordered">
										<thead>
											<tr>
												<th>
													Assessor ID
												</th>
												<th>
													Assessor Name
												</th>
												<th>
													State
												</th>
												<th>
													District
												</th>
												<th>
													Action
												</th>
											</tr>
										</thead>
										<tbody class="notranslate">
											<tr *ngFor="let assessor of assessors; let i = index">
												<td>
													{{assessor.userName}}
												</td>
												<td>
													{{assessor.name}}
												</td>
												<td>
													{{assessor.address?.state?.name}}
												</td>
												<td>
													{{assessor.address?.district?.name}}
												</td>
												<td>
													<input type="radio" name="lo"
														(click)="selectedAssessorIndex(assessor, i)"
														class="form-control notranslate">
												</td>
											</tr>
										</tbody>
									</table>
									<div>
										<app-pagination [count]="assessorLength"
											(pageNumber)="assignPageNoAssessor($event)"
											[defaultRecordsPerPage]="filterPerPage"
											(recordsPerPage)="assignRecordsPerPageAssessor($event)"></app-pagination>
									</div>
									<div class="m-portlet__foot">
										<div class="row">
											<div class="col-lg-6">
												&nbsp;
											</div>
											<div class="col-lg-6 m--align-right">
												<button (click)="assignedAssessor()" [disabled]="assessorIndex"
													class="btn btn-brand">Select</button>
												<button (click)="resetAssessorFilter()" #closeModal type="button"
													class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
													Cancel
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Assign Assessor End -->

<div class="modal fade" id="view_feedback_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true" style="margin-right: 8rem;">
	<div class="modal-dialog modal-lg" role="document">
		<div *ngIf="isFeedbackAvailable" class="modal-content" style="width: 71rem;">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Your Valuable Feedback
				</h5>
				<button type="button" #closeModal class="close" (click)="cancelFeedbackForm()" data-dismiss="modal"
					aria-label="Close">
					<span aria-hidden="true">
						&times;
					</span>
				</button>
			</div>
			<div class="modal-body">
				<div class="m-section">
					<div class="m-section__content">
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Trainer ID:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.userName ? selectedCertificate.userName : 'N/A'}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Trainer Name:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.name ? selectedCertificate.name : 'N/A' }}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch ID:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.batchId ?  selectedCertificate.batchId : 'N/A'}}
								</div>
							</div>
						</div>
						<div class="form-group m-form__group row">
							<label class="col-lg-1">
								<b>Batch Name:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.batchType.name ? selectedCertificate.batchType.name : 'N/A'}}
								</div>
							</div>
							<label class="col-lg-1">
								<b>Batch Date: </b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{(selectedCertificate?.batchStartDate ? (selectedCertificate.batchStartDate| date:"dd-MM-yyyy") : "N/A")}}
									to
									{{(selectedCertificate?.batchEndDate ? (selectedCertificate.batchEndDate | date:"dd-MM-yyyy") : "N/A")}}
								</div>
							</div>
							<!-- <label class="col-lg-1">
                                <b>Batch Type:</b>
                            </label>
                            <div class="col-lg-3">
                                <div class="m-input-icon m-input-icon--right">
                                    {{ selectedCertificate.batchId ? selectedCertificate.batchId : 'N/A'}}
                                </div>
                            </div> -->
							<label class="col-lg-1">
								<b>Date of Submission:</b>
							</label>
							<div class="col-lg-3">
								<div class="m-input-icon m-input-icon--right">
									{{ selectedCertificate.certificateDetails.feedback ? (selectedCertificate.certificateDetails.feedback.date | date: "dd-MM-yyyy") : (todayDate | date: "dd-MM-yyyy")}}
								</div>
							</div>
						</div>
						<hr>
						<form class="m-form">
							<div [formGroup]="feedBackForm">
								<div formGroupName="feedBack">
									<div formGroupName="feedbackForTC" *ngIf="isTCFeedback">
										<div *ngIf="!selectedCertificate.certificateDetails.feedback.feedbackForTC.isTrainingCenter"
											class="row" style="padding-left: 1rem;">
											<label class="m-checkbox col-6">
												<input type="checkbox"
													[checked]="!selectedCertificate.certificateDetails.feedback.feedbackForTC.isTrainingCenter"
													disabled (click)="checkTCValidity($event)"><b>Don't know
													Training Centre details</b>
												<span></span>
											</label>
										</div>
										<div *ngIf="selectedCertificate.certificateDetails.feedback.feedbackForTC.isTrainingCenter"
											class="row" style="padding-bottom: 7px;">
											<label class="col-12">
												<b>Training Centre ID:
													{{ selectedCertificate.certificateDetails.feedback ? selectedCertificate.certificateDetails.feedback.feedbackForTC.tcId : 'N/A' }}</b>
											</label>
										</div>
										<div *ngIf="selectedCertificate.certificateDetails.feedback.feedbackForTC.isTrainingCenter"
											class="row">
											<label class="col-12">
												<b>Training Centre Name:
													{{selectedCertificate.certificateDetails.feedback ? selectedCertificate.certificateDetails.feedback.feedbackForTC.tcName : 'N/A' }}</b>
											</label>
										</div>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Pre-program communication (including ease of
													enrollment and availability of pre-read material):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preCommunication"
															name="preCommunication" value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Content Quality of Study Materials:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfStudyMaterials"
															name="qualityOfStudyMaterials" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Quality of Training/ Assessment Location (or
													Training/ Assessment Platform in case of Online mode):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTraining"
															name="qualityOfTraining" value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Quality of Training and Assessment Tools, Equipment
													and Infrastructure:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=4 class="radio" type="radio">
														<span></span>
													</label>

												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="qualityOfTools" name="qualityOfTools"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Post-program communication/ instructions (including
													support with Skill India Digital Hub, OJT briefing):</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="postCommunication"
															name="postCommunication" value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<hr>
									<div class="form-group m-form__group row">
										<span class="col-12" formGroupName="feedbackForMT" *ngIf="isTrainerFeedback">
											<div *ngIf="!selectedCertificate.certificateDetails.feedback.feedbackForMT[0].isMasterTrainer"
												class="row" style="padding-bottom: 7px;">
												<label class="m-checkbox col-6">
													<input type="checkbox"
														[checked]="!selectedCertificate.certificateDetails.feedback.feedbackForMT[0].isMasterTrainer"
														disabled (click)="checkTrainerValidity($event)"><b>Don't
														know Master Trainer Details</b>
													<span></span>
												</label>
											</div>
											<div *ngIf="selectedCertificate.certificateDetails.feedback.feedbackForMT[0].isMasterTrainer"
												class="row">
												<label class="col-12">
													<b>Master Trainer ID:
														{{ selectedCertificate.certificateDetails.feedback ? selectedCertificate.certificateDetails.feedback.feedbackForMT[0].userName : 'N/A' }}</b>
												</label>
											</div>
											<div *ngIf="selectedCertificate.certificateDetails.feedback.feedbackForMT[0].isMasterTrainer"
												class="row">
												<label class="col-12">
													<b>Master Trainer Name:
														{{ selectedCertificate.certificateDetails.feedback ? selectedCertificate.certificateDetails.feedback.feedbackForMT[0].userName : 'N/A' }}</b>
												</label>
											</div>
											<table class="col-lg-12">
												<thead>
													<th class="width1"></th>
													<th>Highly Satisfied (5)</th>
													<th>Satisfied (4)</th>
													<th>Neutral (3)</th>
													<th>Dissatisfied (2)</th>
													<th>Highly Dissatisfied (1)</th>
												</thead>
												<tr>
													<td class="width1">Knowledge of Subject:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="knowledge" name="knowledge" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Organization and preparation of the sessions:
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=5
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=4
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=3
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=2
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="sessions" name="sessions" value=1
																class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Presentation Style and Delivery:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=5 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=4 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=2 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="presentation" name="presentation"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Usage of Examples of Practical Application:
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=5 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=4 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=2 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="exampleUsage" name="exampleUsage"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Interactive & Participative Approach:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=5 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=4 class="radio" type="radio">
															<span></span>
														</label>

													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=2 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="interactive" name="interactive"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
												<tr>
													<td class="width1">Coverage of Curriculum:</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=5 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=4 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=3 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=2 class="radio" type="radio">
															<span></span>
														</label>
													</td>
													<td class="width2">
														<label class="radio">
															<input formControlName="curriculum" name="curriculum"
																value=1 class="radio" type="radio">
															<span></span>
														</label>
													</td>
												</tr>
											</table>
										</span>
									</div>
									<hr>
									<div formGroupName="feedbackForMTTraining">
										<label class="form-group m-form__group">
											<b>Feedback on Training:</b>
										</label>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Extent of Learning:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningExtent" name="learningExtent"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Learning Environment:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="learningEnvironment"
															name="learningEnvironment" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<hr>
									<div formGroupName="feedbackForAssessor">
										<div *ngIf="!selectedCertificate.certificateDetails.feedback.feedbackForAssessor[0].isAssessor"
											class="row" style="padding-bottom: 7px;">
											<label class="m-checkbox col-6">
												<input type="checkbox" disabled
													[checked]="!selectedCertificate.certificateDetails.feedback.feedbackForAssessor[0].isAssessor"><b>Don't
													know Assessor Details</b>
												<span></span>
											</label>
										</div>
										<div
											*ngIf="selectedCertificate.certificateDetails.feedback.feedbackForAssessor[0].isAssessor">
											<label class="col-12">
												<b>Assessor ID:
													{{ selectedCertificate.certificateDetails.feedback ? selectedCertificate.certificateDetails.feedback.feedbackForAssessor[0].userName : 'N/A' }}</b>
											</label>
										</div>
										<div *ngIf="selectedCertificate.certificateDetails.feedback.feedbackForAssessor[0].isAssessor"
											class="row">
											<label class="col-12">
												<b>Assessor Name:
													{{selectedCertificate.certificateDetails.feedback ? selectedCertificate.certificateDetails.feedback.feedbackForAssessor[0].name : 'N/A'}}</b>
											</label>
										</div>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Pre-Assessment Brief:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=3 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=2 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="preAssessment" name="preAssessment"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Conduct of Assessor:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=5
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=4
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=3
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=2
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="conduct" name="conduct" value=1
															class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
											<tr>
												<td class="width1">Overall Assessment Experience:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=5 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=4 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=3 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=2 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="assessmentExperience"
															name="assessmentExperience" value=1 class="radio"
															type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
									</div>
									<div class="form-group m-form__group row align-data">
										<label class="form-group m-form__group">
											<b>Overall Program Rating</b>
										</label>
										<table class="col-lg-12">
											<thead>
												<th class="width1"></th>
												<th>Highly Satisfied (5)</th>
												<th>Satisfied (4)</th>
												<th>Neutral (3)</th>
												<th>Dissatisfied (2)</th>
												<th>Highly Dissatisfied (1)</th>
											</thead>
											<tr>
												<td class="width1">Overall Program Rating:</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=5 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=4 class="radio" type="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=3 class="radio" type="radio"
															[checked]="overAllRating?.value">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=2 type="radio" class="radio">
														<span></span>
													</label>
												</td>
												<td class="width2">
													<label class="radio">
														<input formControlName="overAllRating" name="overAllRating"
															value=1 class="radio" type="radio">
														<span></span>
													</label>
												</td>
											</tr>
										</table>
										<hr>
									</div>
									<div class="form-group m-form__group row align-data">
										<label class="form-group m-form__group col-12">
											<b>Would you recommend this program to other trainers/assessors?</b>
										</label>
										<td class="width3 col-2">
											<label for="radio">Yes</label>
											<label class="radio">
												<input formControlName="recommendation" name="recommendation"
													value="Yes" class="radio" type="radio">
												<span></span>
											</label>
										</td>
										<td class="width4">
											<label for="radio">No</label>
											<label class="radio">
												<input formControlName="recommendation" name="recommendation" value="No"
													class="radio" type="radio">
												<span></span>
											</label>
										</td>
										<hr>
									</div>
									<div>
										<label class="form-group m-form__group">
											Comment:
										</label>
										<div>
											<textarea type="text" formControlName="overAllComment"
												class="form-control m-input" rows="5"
												placeholder="Your comments goes here..."></textarea>
											<app-form-control-messages class="col-12"
												[control]="feedBackForm.get('feedBack').get('overAllComment')['controls']"
												[name]="'Comments'"></app-form-control-messages>
										</div>
									</div>
									<div class="modal-footer">
										<button type="button" class="btn btn-secondary" data-dismiss="modal"
											(click)="cancelFeedbackForm()">
											Cancel
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>

<!-- <div class="m-content portlet-top">
    <div class="m-content padding">
        <form class="m-portlet m-portlet--mobile">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text notranslate">
                            <strong>Assign Training Centre</strong>
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body">
                <div class="tab-content" [formGroup]="trainingCentreSearchForm">
                    <div class="form-group m-form__group">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>
                                            State:
                                        </label>
                                        <div class="notranslate">
                                            <angular2-multiselect (onOpen)="stateClick()"
                                                (onSelect)="onStateSelect($event)"
                                                formControlName="state" [data]="stateDropDownData"
                                                [(ngModel)]="selectedItemsState" [settings]="settings">
                                            </angular2-multiselect>
                                            <app-form-control-messages class="col-12"
                                                [control]="trainingCentreSearchForm.get('state')"
                                                [name]="'State'"></app-form-control-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label>
                                            District:
                                        </label>
                                        <div class="notranslate">
                                            <angular2-multiselect (onOpen)="districtClick()"
                                                formControlName="district"
                                                (onSelect)="onDistrictSelect($event)"
                                                [data]="districtDropDownData"
                                                [(ngModel)]="selectedItemsDistrict"
                                                [settings]="settings">
                                            </angular2-multiselect>
                                            <app-form-control-messages class="col-12"
                                                [control]="trainingCentreSearchForm.get('district')"
                                                [name]="'District'"></app-form-control-messages>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label>
                                            Training Centre ID:
                                        </label>
                                        <input class="notranslate" type="text"
                                            formControlName="trainingCentreId" class="form-control"
                                            placeholder="Enter Training Centre Id">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>
                                            Type :
                                        </label>
                                        <div class="notranslate">
                                            <angular2-multiselect formControlName="trainingCentreType"
                                                (onSelect)="trainingCentreTypeSelect($event)"
                                                [data]="trainingCentreTypeDropdownData"
                                                [(ngModel)]="selectedItemsTrainingCentreType"
                                                [settings]="settings">
                                            </angular2-multiselect>
                                        </div>
                                    </div>
                                    <div style="margin-top:30px">
                                        <button (click)="searchTC('assign')" type="button"
                                            class="btn btn-secondary" data-toggle="modal"
                                            [attr.data-target]="'#' + searchTCPopup">Search</button><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table">
                            <thead style="background :#bac1d4">
                                <tr>
                                    <th>
                                        Training Centre
                                    </th>
                                    <th>
                                        Training Centre ID
                                    </th>
                                    <th>
                                        Centre Rating
                                    </th>
                                    <th>
                                        Training Partner Name
                                    </th>
                                    <th>
                                        State
                                    </th>
                                    <th>
                                        District
                                    </th>
                                    <th>
                                        Status
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="notranslate">
                                <tr>
                                    <td>
                                        <span class="m-demo__preview m-demo__preview--badge"
                                            *ngIf="batch?.exceptionalTC">
                                            <span
                                                class="m-badge m-badge--info m-badge--wide m-badge--rounded">E</span>
                                        </span> {{batch?.tcName}}
                                    </td>
                                    <td>
                                        {{batch?.tcId}}
                                    </td>
                                    <td>
                                        <div *ngIf="batch.hasOwnProperty('rating') ; else showNARating">
                                            <span>{{batch.rating}}</span>
                                        </div>
                                        <ng-template #showNARating>
                                            <span *ngIf="batch.hasOwnProperty('tcId')">NA</span>
                                        </ng-template>

                                    </td>
                                    <td>

                                        <div *ngIf="batch.hasOwnProperty('tpName') ; else showNATP">
                                            <span>{{batch?.tpName}}</span>
                                        </div>
                                        <ng-template #showNATP>
                                            <span *ngIf="batch.hasOwnProperty('tcId')">NA</span>
                                        </ng-template>
                                    </td>
                                    <td>
                                        {{batch.address?.state?.name}}

                                    </td>
                                    <td>
                                        {{batch.address?.district?.name}}

                                    </td>
                                    <td>
                                        <span *ngIf="batch.tcApproved ==='NEW'">Assigned</span>
                                        <span *ngIf="batch.tcApproved ==='ACCEPTED'">Accepted</span>
                                        <span *ngIf="batch.tcApproved === 'REJECTED'">Rejected</span>

                                    </td>
                                    <td>
                                        <span style="overflow: visible; width: 100px;"
                                            *ngIf="batch?.tcId">
                                            <div class="dropdown">
                                                <a href="javascript:;"
                                                    class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                                    data-toggle="dropdown">
                                                    <i class="la la-ellipsis-h"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-left">
                                                    <span data-toggle="modal">
                                                        <a (click)="searchTC('reassign')"
                                                            class="dropdown-item"
                                                            style="cursor: pointer;"
                                                            [attr.data-target]="'#' + searchTCPopup"
                                                            data-toggle="modal">
                                                            <span class="m-nav__link-text hover-font">
                                                                {{(batch?.tcApproved === 'REJECTED' || 'Assigned')? "Reassign Training Centre" : "Assign Training Centre"}}
                                                            </span>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div> -->


<!-- <div class="form-group m-form__group row">
            <table class="col-sm-11 notranslate table table-striped m-table">
            <thead>
                <tr>
                <th>Sr. No.</th>
                <th>Sector Skill Council</th>
                <th>Job Role Name</th>
                <th>User Type</th>
                <th>Certification ID</th>
                <th>Valid Till</th>
                <th>Status</th>
                <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let scheme of schemeData; let i = index">
                <td>1</td>
                <td>Sector Skill</td>
                <td>Job Role</td>
                <td>User Type</td>
                <td>Certification Id</td>
                <td>Valid Till</td>
                <td>Status</td>
                <td data-field="Actions" class="m-datatable__cell">
                    <span style="overflow: visible; width: 100px;">
                    <div class="dropdown">
                        <div class="dropdown-menu dropdown-menu-right">
                        <span class="dropdown-item" style="cursor: pointer">
                            Enter Retirement Date
                        </span>
                        </div>
                    </div>
                    </span>
                </td>
                </tr>
            </tbody>
            </table>
            <div>
            <app-pagination [count]="length" [defaultRecordsPerPage]="perPage" (pageNumber)="assignPageNo($event)"
                (recordsPerPage)="assignRecordsPerPage($event)"></app-pagination>
            </div>
        </div> -->
